<template>
  <fusioncharts
      :type="type"
      :width="width"
      :dataformat="dataFormat"
      :dataSource="dataSource"
  />
</template>

<script>
  const dataSource = {
    chart: {
      caption: "GMV по месяцам в разрезе терминалов",
      xAxisname: 'Номер месяца',
      yAxisname: 'Сумма по полю',
      theme: "fusion"
    },
    categories: [
      {
        category: [
          { label: "«ЗТК Тамань» ООО" },
          { label: "ООО «НЗТ»" },
          { label: "ПАО «НКХП»" }
        ]
      }
    ],
    dataset: [
      {
        seriesname: '3',
        data: [{ value: null }, { value: 7088.40 }, { value: 6190.30 }]
      },
      {
        seriesname: '4',
        data: [{ value: null }, { value: 373.45 }, { value: 4218.80 }]
      },
      {
        seriesname: '7',
        data: [{ value: 50.52 }, { value: 54478.80 }, { value: 4099.52 }]
      },
      {
        seriesname: '8',
        data: [{ value: 281.87 }, { value: 21625.30 }, { value: 18475.50 }]
      },
      {
        seriesname: '9',
        data: [{ value: 10338.50 }, { value: 14635.65 }, { value: 12259.24 }]
      },
      {
        seriesname: '10',
        data: [{ value: 14357.82 }, { value: 41879.03 }, { value: 24613.60 }]
      },
      {
        seriesname: '11',
        data: [{ value: null }, { value: 57155.80 }, { value: 29941.62 }]
      },
      {
        seriesname: '12',
        data: [{ value: 17519.29 }, { value: 30044.05 }, { value: 6998.08 }]
      }
    ]
  };

  export default {
    data() {
      return {
        type: "mscolumn2d",
        width: 800,
        dataFormat: "json",
        dataSource
      };
    }
  }
</script>

<style scoped>

</style>